import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { Modal } from '../../../components/ui/Modal';
import { sheetClosed, sheetOpened } from '../../../features/operator/operatorDeviceSlice';

/**
 * A dialog that rises from the bottom edge, where the thumb is. While one is
 * open the camera pauses: what it would read is under the sheet.
 *
 * Takes `Modal`'s props; `placement` is always `sheet`.
 */
export const OperatorSheet = ({ isOpen, ...props }) => {
  const dispatch = useDispatch();

  useEffect(() => {
    if (!isOpen) return undefined;
    dispatch(sheetOpened());
    return () => {
      dispatch(sheetClosed());
    };
  }, [isOpen, dispatch]);

  return <Modal isOpen={isOpen} placement="sheet" {...props} />;
};
